import React, {useEffect, useRef, useState} from 'react';
import FormHook from '../../util/FormHook/FormHook';
import {Button, Col, FormGroup, Label, Row} from 'reactstrap';
import {addInstructorAction, cancelGetInstructorsActionFn, updateInstructorAction, uploadInstructorCurriculumAction} from '../../actions/instructor';
import {connect} from 'react-redux';
import * as types from '../../types';
import {myDispatch, registerDispatch} from '../../actions/util';
import {InstructorExperticeList, InstructorGradeLevelsList} from '../index';
import AvatarEditor from 'react-avatar-editor'
import Input from "reactstrap/es/Input";
import {instructorService} from "../../services";
import { useHistory, useLocation } from "react-router-dom";

const InstructorForm = ({
                          CRUDInstructor,
                          instructor,
                          isFetching,
                          addInstructorAction,
                          updateInstructorAction,
                          instructorService,
                          toggleForm,
                          formInstructorId
                        }) => {

  let history = useHistory();
  let location = useLocation();

  const [avatar, setAvatar] = useState("data:image/png;base64, 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");
  const [curriculum, setCurriculum] = useState(null);

  useEffect(() => {
    if (instructor.id) {
      instructorService().getAvatar(instructor.id).then(res => {
        setAvatar("data:image/png;base64, " + res.data);
      }).catch((err) => {

      });
    }
    // eslint-disable-next-line
  }, [setAvatar, instructorService, instructor]);

  const avatarRef = useRef();

  const sectionStyle = {
    border: '1px solid #e9e9e9',
    borderRadius: '6px',
    padding: '.75rem .75rem 0',
    marginBottom: '5px'
  };
  const actionsStyle = {
    margin: '15px 0',
    padding: '10px 0',
    width: '100%',
    borderTop: '1px solid #e9e9e9'
  };


  return (
    <div style={{padding: '20px 0px'}}>
      <Row style={{margin: '0px 0px 10px'}}>
            <span
              style={{
                cursor: 'pointer',
                color: '#17a2b8',
                fontSize: '12px'
              }}
              onClick={() => {
                history.push({...location, hash: ""});
                toggleForm();
              }}
            >
              Instructors >&nbsp;
            </span>
        <span style={{color: 'rgb(108, 117, 125)', fontSize: '12px'}}>
              {CRUDInstructor === types.CREATE_INSTRUCTOR
                ? 'New Instructor'
                : 'Update Instructor'}
            </span>
      </Row>
      <Row>
        <FormHook

          key={formInstructorId}
          className='col-md-6 col-12'
          defaultValues={instructor}
          submit={values => {
            cancelGetInstructorsActionFn(false);
            // console.log(avatarRef.current, avatarRef.current.getImage(), avatarRef.current.getImageScaledToCanvas());
            const canvas = avatarRef.current.getImageScaledToCanvas().toDataURL();
            // let imageURL;

            const submit = (blob) => {

              if (CRUDInstructor === types.CREATE_INSTRUCTOR) {
                addInstructorAction(values.name, values.lastName, values.email, values.biography, curriculum, blob);
              } else if (CRUDInstructor === types.UPDATE_INSTRUCTOR) {
                updateInstructorAction({...values, curriculum, blob});
              }
            };

            if (avatarRef.current != null) {
              fetch(canvas)
                .then(res => res.blob())
                .then(blob => {
                  // TODO: have send the blob to the server
                  // console.log(blob);
                  submit(blob);
                  // if you want to show the result in a image use <img src={imageURL}/>
                  // imageURL = window.URL.createObjectURL(blob);
                });
            } else {
              submit();
            }

          }}
        >
          <div>
            <Row style={{marginLeft: '0px'}}>
              <h5>
                {CRUDInstructor === types.CREATE_INSTRUCTOR ? 'New' : 'Update'}{' '}
                Instructor
              </h5>
            </Row>
            <div style={{maxWidth: '800px', marginTop: '10px'}}>
              {CRUDInstructor === types.UPDATE_INSTRUCTOR && instructor.id && (
                <input type='hidden' name='id'/>
              )}
              <div style={sectionStyle}>
                <Row>

                  <div className='col-8'>
                    <FormGroup row>
                      <Label sm={3} style={{marginTop: '18px'}}>
                        Name
                      </Label>
                      <Col sm={8}>
                        <input name='name' required maxLength={100}/>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label sm={3} style={{marginTop: '18px'}}>
                        Last Name
                      </Label>
                      <Col sm={8}>
                        <input name='lastName' required maxLength={100}/>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label sm={3}>
                        Email
                      </Label>
                      <Col sm={8}>
                        <input type="email" name='email' required/>
                      </Col>
                    </FormGroup>
                    <div className="text-right" style={{paddingRight: "30px"}}>
                      <Button color="primary fileContainer mb-1" outline>
                        <Input type="file" name="curriculum" accept=".pdf" onChange={(e) => {
                          // console.log("e", e.target.files[0])
                          if (e.target.files[0]) {
                            setCurriculum(e.target.files[0]);
                            // uploadInstructorCurriculumAction(instructor.id,e.target.files[0])
                          }
                        }}/>
                        Upload curriculum
                      </Button>
                      {curriculum && curriculum.name && <span style={{position: "absolute", fontSize: "10px", right: "40px", bottom: "-10px", color: "#00b0c2"}}>{curriculum.name}</span>}
                    </div>
                  </div>
                  <div className='col-4 text-center'>

                    <AvatarEditor
                      ref={avatarRef}
                      image={avatar}
                      width={128}
                      height={128}
                      border={10}
                      color={[0, 0, 0, 0.2]} // RGBA
                      scale={1}
                      rotate={0}
                    />
                    <Button color="primary fileContainer" outline>
                      <Input type="file" name="avatar" accept="image/*" onChange={(e) => {
                        // console.log("e", e.target.files[0])
                        if (e.target.files[0]) {
                          setAvatar(e.target.files[0]);
                        }
                      }}/>
                      Avatar
                    </Button>
                  </div>

                </Row>
                <FormGroup row>
                  <Label sm={2} style={{marginTop: '17px'}}>
                    Biography
                  </Label>
                  <Col sm={10}>
                    <textarea name='biography' style={{height: '300px'}} maxLength={10000}/>
                  </Col>
                </FormGroup>
              </div>
            </div>
            <div style={actionsStyle}>
              <Button color='primary'>
                {CRUDInstructor === types.CREATE_INSTRUCTOR ? 'Save' : 'Update'}
                {isFetching ? '...' : ''}
              </Button>
              <Label>&nbsp;or&nbsp;</Label>
              <span
                style={{cursor: 'pointer', color: '#17a2b8'}}
                onClick={() => {
                  history.push({...location, hash: ""});
                  toggleForm();
                }}
              >
              Cancel
            </span>
            </div>
          </div>
        </FormHook>
        {CRUDInstructor === types.UPDATE_INSTRUCTOR && (
          <div className='col-md-6 col-12'>
            <InstructorExperticeList/>
            <InstructorGradeLevelsList/>

          </div>

        )}
      </Row>
    </div>
  );
};
const mapStateToProps = ({isFetching, CRUDInstructor, instructor, formInstructorId}) => ({
  isFetching,
  CRUDInstructor,
  instructor,
  formInstructorId
});

const mapDispatchProps = dispatch => {
  registerDispatch(dispatch);
  return {
    addInstructorAction,
    uploadInstructorCurriculumAction,
    updateInstructorAction,
    instructorService,
    toggleForm: () => {
      cancelGetInstructorsActionFn(false);
      dispatch(myDispatch(types.TOGGLE_INSTRUCTOR_FROM));
      dispatch(myDispatch(types.RESET_INSTRUCTOR));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(InstructorForm);
